<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z9HCdQ/images/cover.jpg?1696786155664" alt="This image is the cover for the book Notorious San Juans, Wicked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Notorious San Juans, Wicked
      </h1>
      <p class="bookDescription body article font2">
        <p>From the shooting of a Secret Service agent in the wilds near Hesperus to the "grave misfortune"? of Kid Adams, a not-so-successful highwayman, these tales from the lofty heights of the San Juans are packed with mystery, pathos and fascinating historical details. Mined from the frontier newspapers of Ouray, San Juan and La Plata Counties, these stories tell of range wars, desperadoes and cattle rustlers, lynchings, ill-tempered ranchers with trigger fingers and women fed up with their husbands. There are famous and infamous newsmen, wild stagecoach rides, scapegoats and stolen lands. Carol Turner's Notorious San Juansoffers a rowdy ride through the region's not-so-quiet history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Turner
      </h2>
      
      <p class="authorDescription body article">Carol Turner has a BA in English from Sonoma State University and an MFA in creative writing and literature from Bennington College. She is the author of Economics for the Impatient, and her short fiction has appeared in numerous literary magazines. She lives in Colorado, writes a history column for the Broomfield Enterprise and maintains a Colorado history blog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a1525d4